export const tableControlBaseClasses =
  "h-[34px] rounded-control border-0 bg-white text-sm font-medium text-muted-dark outline-none transition placeholder:text-muted focus:ring-2 focus:ring-accent/30";

export const tableControlContainerClasses =
  "w-full rounded-control bg-surface-subtle p-3 font-medium text-muted";

export const tableDatePickerClasses =
  "!mb-0 [&_.MuiOutlinedInput-root]:!h-[34px] [&_.MuiOutlinedInput-root]:!bg-white [&_.MuiOutlinedInput-root]:!font-medium [&_.MuiOutlinedInput-notchedOutline]:!border-0 [&_.MuiOutlinedInput-input]:!py-0 [&_.MuiOutlinedInput-input]:!text-sm";
